import { gql } from '@apollo/client';

export const ALL_SESSION_ATTENDEES = gql`
  query AllSessionAttendees($input: AttendeesFilter!) {
    attendees: allAttendees(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          attendance {
            id
            session {
              id
            }
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          cohorts {
            id
            name
          }
          role {
            id
            name
          }
          country {
            id
            name
          }
          grades {
            id
            value
            name
          }
          primaryInstitution {
            id
            name
          }
          institutions {
            id
            name
          }
          associatedInstitutions {
            id
            startDate
            endDate
            institution {
              id
              name
            }
          }
          phase {
            id
            name
          }
          type {
            id
            name
          }
        }
        cursor
      }
    }
  }
`;
